<mat-spinner
  class="spinner-middle"
  *ngIf="!init"
  color="primary"
  diameter="24"
></mat-spinner>

<mat-dialog-content class="company-display-dialog">
  <h2>{{ company.regularName }}</h2>
  <div class="form-title upper-space">
    <div class="form-title-text">Adres</div>
  </div>
  <div *ngIf="displayAddress == null">Geen adres</div>
  <div *ngIf="displayAddress != null">
    <div>{{ displayAddress.line1 }}</div>
    <div>{{ displayAddress.postalCode | joiner: ' ':displayAddress.city }}</div>
  </div>
  <div class="form-title upper-space">
    <div class="form-title-text">Contacten</div>
  </div>
  <ng-container *ngIf="displayContacts?.length > 0">
    <ul class="inpress-ul">
      <li *ngFor="let contact of displayContacts">
        <span class="strong"
          >{{ contact.firstName | joiner: ' ':contact.lastName }}:
        </span>
        <span *ngFor="let phone of contact.telephones; let first = first">
          <span *ngIf="!first">&nbsp;/&nbsp;</span>
          <a class="click-link" href="tel:{{ phone.number }}">
            {{ phone.number | asFormatPhoneNumber }}
          </a>
        </span>
      </li>
    </ul>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions class="float-right">
  <button
    type="button"
    (click)="closeDialog()"
    mat-button
    class="button"
    id="btnClose"
  >
    Ok
  </button>
</mat-dialog-actions>
